import type { ShareButtonSignature } from '@efdigital/ll-addon-content/types/components/parts/share-button';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const ShareButton: TemplateOnlyComponent<ShareButtonSignature> = <template>
  <button
    type="button"
    class="btn btn-outline-primary btn-sm"
    ...attributes
  >Share</button>
</template>;

export { ShareButton };
